import { ComputedDatum } from '@nivo/circle-packing'
import styled from 'styled-components'
import moment from 'moment'
import { getShortenedAddress } from '../../../utils/address'
import ProfileImage from '../../profile/image'

const UserDiv = styled.div`
  display: inline-flex;
  align-items: center;
  flex-direction: row;
  border-radius: 35px;
  /* height: 24px; */
  background: #000;
  width: fit-content;
  padding: 15px;
  /* margin-top: 8px;
  margin-bottom: 8px; */
`

const Details = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 8px;
  margin-right: 4px;
`

const Name = styled.div`
  font-weight: 600;
  color: white;
  overflow: hidden;
  font-size: 14px;
`

const Amount = styled.div`
  font-weight: 400;
  color: white;
  font-size: 12px;
`

export const CollectorTooltip = <RawDatum,>({ id, data }: ComputedDatum<RawDatum>): JSX.Element => {
  const collector = data as any

  return (
    <UserDiv>
      <ProfileImage item={collector.user} size={35} />
      <Details>
        <Name>{collector.user?.displayName ?? getShortenedAddress(id)}</Name>
        <Amount>
          {`${collector.owned} edition${collector.owned > 1 ? 's' : ''}` +
            ' · ' +
            `Supporter for ${moment(collector.time).fromNow(true)}`}
        </Amount>
      </Details>
    </UserDiv>
  )
}
